export default {
  "primaryColor": "#ccc",
  "lightColor": "#ccc",
  "darkColor": "#999"
};